export default __webpack_public_path__ + "static/media/RajaRajeswari.3dcdc4f1.png";